import { render, staticRenderFns } from "./PageBlocked.vue?vue&type=template&id=cbf6d8b6&"
import script from "./PageBlocked.vue?vue&type=script&lang=js&"
export * from "./PageBlocked.vue?vue&type=script&lang=js&"
import style0 from "./PageBlocked.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports